import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  adminGetConfig,
  adminPutConfig,
  isUnauthorized,
  type PublicConfig,
} from '../lib/api';
import AdminNav from './AdminNav';

const empty: PublicConfig = {
  price_standard_cents: '',
  price_deep_cents: '',
  xianyu_url_standard: '',
  xianyu_url_deep: '',
};

export default function AdminConfig() {
  const navigate = useNavigate();
  const [form, setForm] = useState<PublicConfig>(empty);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const cfg = await adminGetConfig();
        setForm(cfg);
      } catch (err) {
        if (isUnauthorized(err)) {
          navigate('/admin/login', { replace: true });
          return;
        }
        setError('配置加载失败');
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  function setField<K extends keyof PublicConfig>(key: K, value: string) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    setMsg('');
    try {
      const saved = await adminPutConfig({
        price_standard_cents: form.price_standard_cents.trim(),
        price_deep_cents: form.price_deep_cents.trim(),
        xianyu_url_standard: form.xianyu_url_standard.trim(),
        xianyu_url_deep: form.xianyu_url_deep.trim(),
      });
      setForm(saved);
      setMsg('已保存');
    } catch (err) {
      if (isUnauthorized(err)) {
        navigate('/admin/login', { replace: true });
        return;
      }
      setError('保存失败，请检查价格是否为整数分');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="stack">
      <AdminNav />
      <div className="card">
        <h2>站点配置</h2>
        <p className="muted">价格单位为分（如 1990 = ¥19.90）。闲鱼链接会展示在支付页。</p>
        {loading ? <p className="muted">加载中…</p> : null}
        {error ? <div className="error">{error}</div> : null}
        {msg ? <div className="success">{msg}</div> : null}
        {!loading ? (
          <form className="stack" onSubmit={onSubmit} style={{ marginTop: '1rem' }}>
            <label className="field">
              标准档价格（分）
              <input
                type="text"
                inputMode="numeric"
                value={form.price_standard_cents}
                onChange={(e) => setField('price_standard_cents', e.target.value)}
                required
              />
            </label>
            <label className="field">
              深度档价格（分）
              <input
                type="text"
                inputMode="numeric"
                value={form.price_deep_cents}
                onChange={(e) => setField('price_deep_cents', e.target.value)}
                required
              />
            </label>
            <label className="field">
              标准档闲鱼链接
              <input
                type="text"
                value={form.xianyu_url_standard}
                onChange={(e) => setField('xianyu_url_standard', e.target.value)}
                placeholder="https://…"
              />
            </label>
            <label className="field">
              深度档闲鱼链接
              <input
                type="text"
                value={form.xianyu_url_deep}
                onChange={(e) => setField('xianyu_url_deep', e.target.value)}
                placeholder="https://…"
              />
            </label>
            <div className="row">
              <button type="submit" className="btn" disabled={busy}>
                {busy ? '保存中…' : '保存配置'}
              </button>
            </div>
          </form>
        ) : null}
      </div>
    </section>
  );
}
